<template>
  <div class="News">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="contain">
      <ComDetails :infoColumn="infoColumn" baseUrl="professional"></ComDetails>
    </div>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner";
import ComDetails from "../../components/news/comDetails";
export default {
  name: "News",
  metaInfo() {
    return {
      title: "行业人才详情",
      meta: [
        { name: "keywords", content: "keywords详情测试" },
        { name: "description", content: "description详情测试" },
      ],
    };
  },
  data() {
    return {
      bannerObj: {
        lableZh: "行业人才",
        lableEn: "NEWS",
        bannerImg: require("../../assets/img/professional_banner.png"),
      },
      infoColumn: this.$route.query.infoColumn,
    };
  },

  mounted() {
    // 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      new this.$wow({
        //默认为true
        live: false,
      }).init();
    });
  },
  components: { PageBanner, ComDetails },
};
</script>
<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.contain {
  margin-top: -134px;
  position: relative;
  z-index: 66;
}
</style>
